export const baseUrl = '//hszc.biz.weibo.com';
export const detailUrl = 'https://m.weibo.cn/detail/';
export const profileUrl = 'https://m.weibo.cn/u/';